import noUiSlider from 'nouislider'
import wNumb from 'wnumb'

const $sort = $('#filter-sort'),
    $fakeSortButtons = $('.js-fake-sort-buttons'),
    $fakeSort = $('select#fake-sort'),
    $view = $('#filter-view'),
    $fakeView = $('.js-fake-view'),
    $limit = $('#limit'),
    $fakeLimit = $('.js-filter-fake-limit');

let $rangeSlider;

Listing.customCallbacks.beforeFetch = () => {
    rEvent.dispatch('Listing.customBeforeFetch');
}

function updateFilterBubbles() {
    const withoutFilterBubbles = $('.js-filter-bubbles-item').length < 1;

    if (withoutFilterBubbles) {
        $('.js-filter-bubbles-reset').remove();
    }

    $('.js-filter-bubbles').toggleClass('is-empty', withoutFilterBubbles);
    $('.js-filter-submit-holder').toggleClass('without-bubbles', withoutFilterBubbles);
}

function renderFilterBubbles() {
    updateFilterBubbles();

    rEvent.on('FilterBubbles.afterRefresh', function () {
        updateFilterBubbles();
    });

    $('body').on('change', '.c-aside-filter [type="checkbox"]', function () {
        updateFilterBubbles();
    });

    // filter bubbles reset hide
    $('body').on('click', '.js-filter-bubbles-item', function () {
        requestAnimationFrame(() => {
            updateFilterBubbles();
        });
    });

    $('body').on('click', '.js-filter-bubbles-reset', function () {
        $('.c-aside-filter').find('[type="reset"]').click();
        updateFilterBubbles();
    });
}

const renderMultiselect = () => {
    $('#filter select').not('.is-loaded').each(function () {
        const $select = $(this);
        let options = {
            templates: {
                button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><span class="multiselect-selected-text"></span><i class="ico ico-triangle-down is-on-right"></i></button>',
            },
            buttonClass: 'c-btn has-icon',
            enableHTML: true
        };

        if ($select.closest('#filter').length) {
            const moreText = $select.data('more-text')
            const lessText = $select.data('less-text')

            options.templates.ul = `
                <r-more-items r-more-items-self-target class="multiselect-container dropdown-menu" data-more-text="${moreText}" data-less-text="${lessText}">
                    <button type="button" class="c-link c-link--blue is-more has-icon" r-more-items-trigger>
                        <span r-more-items-trigger-text>${moreText}</span>
                        <i class="ico ico-caret-down-thick is-on-right"></i>
                    </button>
                </r-more-items>
            `;
            options.templates.filter = `
                <div class="multiselect-item multiselect-filter">
                    <div class="c-form__item c-form__item--text">
                        <input class="c-form__input multiselect-search" type="text">
                        <i class="ico ico-search"></i>
                    </div>
                </div>
            `;
            options.filterPlaceholder = $select.data('filter-text');
            options.enableCaseInsensitiveFiltering = true;
            options.onFiltering = (input) => {
                const $input = $(input);
                const $dropdownMenu = $input.closest('.dropdown-menu')

                if ($input.val()) {
                    $dropdownMenu.addClass('is-filtering');
                }
                if (!$input.val()) {
                    $dropdownMenu.removeClass('is-filtering');

                    $dropdownMenu.find('li').each(function () {
                        $(this).css('display', '');
                    });
                }
            };
        }

        $select.multiselect(options);
        $select.addClass('is-loaded');
    });

    requestAnimationFrame(() => {
        addMultiselectCounts()
        addFilterAndMore()
    })
}

const addMultiselectCounts = () => {
    $('#filter').find('select[type="multiselect"]').each(function () {
        const $select = $(this),
            $options = $select.find('option'),
            $dropdownMenu = $select.next().find('.dropdown-menu'),
            type = $select.data('type');

        $options.each(function () {
            const $option = $(this),
                count = $option.data('count'),
                value = $option.val(),
                $fakeInput = $dropdownMenu.find('input[value="' + value + '"]'),
                $fakeInputLabel = $fakeInput.parent();

            if (count && !$fakeInputLabel.find('.count').length) {
                $fakeInputLabel.append(count);
                $fakeInput.parents('a')
                    .attr('data-element', 'filterItem')
                    .attr('data-type', type)
                    .attr('data-field-value', value)
                    .attr('data-count', count.replace(/<[^>]*>?/gm, '').replace(/[()]/g, ''));
            }
        });
    });
}

const addFilterAndMore = () => {
    $('#filter').find('select[type="multiselect"]').each(function () {
        const $dropdownMenu = $(this).next().find('.dropdown-menu');
        const $options = $dropdownMenu.find('li');

        if ($options.length > 6) {
            $dropdownMenu.addClass('hide-items');
            $options.each(function (key, item) {
                if (key > 3) {
                    $(this).addClass('is-hidden');
                }
            });
        }
    });
}

function updateRangeCallback(selectors, values, sliderInstance) {
    const $from = $(selectors.from),
        $to = $(selectors.to),
        fromVal = $from.val(),
        toVal = $to.val(),
        minValue = sliderInstance.options.range.min[0],
        maxValue = sliderInstance.options.range.max[0];

    if (minValue == values[0] && maxValue == values[1]) {
        // $from.val('').removeAttr('value');
        // $to.val('').removeAttr('value');

        // Filter.submit();

        // return true;
    }

    $from.val(Number(values[0]));
    $to.val(Number(values[1]));

    /*if (!fromVal && !toVal) {
        $to.trigger('change');
    }
    else if (fromVal === values[0]) {
        $to.trigger('change');
    }
    else if (toVal === values[1]) {
        $from.trigger('change');
    }*/
    Filter.submit();
}

function createPriceRange() {
    const $elem = $('.js-range-price'),
        $slider = $elem.find('.range-slider__slider'),
        maxValue = Number($elem.attr('data-max')),
        minValue = Number($elem.attr('data-min')),
        fromValue = Number($elem.attr('data-from')),
        toValue = Number($elem.attr('data-to')),
        currencySymbol = Eshop.options.currency.symbol_right;

    if (!$slider.length) {
        return false;
    }

    $rangeSlider = noUiSlider.create($slider[0], {
        start: [fromValue, toValue],
        range: {
            'min': [minValue],
            'max': [maxValue]
        },
        margin: 1,
        connect: true,
        tooltips: [
            wNumb({
                decimals: 0,
                suffix: ` ${currencySymbol}`
            }),
            wNumb({
                decimals: 0,
                suffix: ` ${currencySymbol}`
            })
        ],
        step: 1
    });

    $rangeSlider.on('change', function (values, handle) {
        updateRangeCallback({
            from: '[name="filter[price][from]"]',
            to: '[name="filter[price][to]"]'
        }, values, this);

        $('.js-filter-price-range:checked').prop('checked', false);
    });

    $('#filter-price-from, #filter-price-to').on('keydown', function (event) {
        if (event.which == 13 || event.keyCode == 13) {
            event.preventDefault();

            $(this).blur();
            $(this).trigger('change');
        }
    });

    $('#filter-price-from').on('change', function (event) {
        event.preventDefault();

        const min = Number($(this).attr('min')),
            inputToValue = Number($('#filter-price-to').val());

        let value = Number($(this).val()),
            setInput = false;

        if (value < min) {
            value = min;
            setInput = true;
        }
        else if (value > inputToValue) {
            value = inputToValue;
            setInput = true;
        }

        if (setInput) {
            $(this).val(value);
        }

        $rangeSlider.set([value, null]);
    });

    $('#filter-price-to').on('change', function (event) {
        event.preventDefault();

        const max = Number($(this).attr('max')),
            inputFromValue = Number($('#filter-price-from').val());

        let value = Number($(this).val()),
            setInput = false;

        if (value > max) {
            value = max;
            setInput = true;
        }
        else if (value < inputFromValue) {
            value = inputFromValue;
            setInput = true;
        }

        if (setInput) {
            $(this).val(value);
        }

        $rangeSlider.set([null, value]);
    });
}

const changeFakeSortButton = (value) => {
    $fakeSortButtons.find('.c-btn').removeClass('is-active');
    $fakeSortButtons.find(`.c-btn[data-value="${value}"]`).addClass('is-active');
}

rEvent.on('Listing.customBeforeFetch', function () {
    if ($('.listing__holder').length) {
        $('.listing__holder').addClass('is-loading');
    }
    if ($('.c-msg.is-empty.listing').length) {
        $('.c-msg.is-empty.listing').addClass('is-loading');
    }
});

rEvent.on('Listing.fetchedData', function (data) {
    requestAnimationFrame(() => {
        if ($('.listing__holder').length) {
            $('.listing__holder').removeClass('is-loading');
        }

        if ($('.pager__load').length) {
            $('.pager__load').removeClass('is-loading');
        }
    })

    const $listingCount = $('.js-listing-count');

    if ($listingCount.length) {
        $listingCount.each(function () {
            const $countElem = $(this);
            let countHtml = data.count;

            if ($countElem.hasAttr('data-plural')) {
                const listingPlural = $countElem.data('plural');

                countHtml = data.count + ' ' + Format.plural(listingPlural[0], listingPlural[1], listingPlural[2], data.count);
            }

            if ($countElem.hasAttr('data-template')) {
                countHtml = $countElem.data('template').replace(':value:', countHtml);
            }

            $countElem.html(countHtml)
        });
    }
});

// ---------------------------------------------------------------------------
// Property range slider
// ---------------------------------------------------------------------------

function createPropertySliders() {
    const $elems = $('.js-range-property');

    $elems.each(function () {
        const $elem = $(this);
        const $slider = $elem.find('.range-slider__slider');
        const propertyId = $elem.attr('data-property-id');
        const maxValue = parseFloat($elem.attr('data-max'));
        const minValue = parseFloat($elem.attr('data-min'));
        const fromValue = parseFloat($elem.attr('data-from'));
        const toValue = parseFloat($elem.attr('data-to'));
        const unit = ($elem.attr('data-unit') || '').trim();

        if (!$slider.length || $slider.hasClass('noUi-target')) {
            return;
        }

        const wNumbFormat = wNumb({ decimals: 0 });
        const wNumbDisplayFormat = wNumb({ decimals: 0, suffix: unit ? ' ' + unit : '' });

        const rangeSlider = noUiSlider.create($slider[0], {
            start: [fromValue, toValue],
            range: { min: [minValue], max: [maxValue] },
            step: 1,
            connect: true,
            tooltips: [wNumbDisplayFormat, wNumbDisplayFormat],
            format: wNumbFormat,
        });

        $elem.data('rangeSlider', rangeSlider);

        const $container = $elem.closest('.filter-property-slider');
        const $fromInput = $container.find('.filter-property-from');
        const $toInput = $container.find('.filter-property-to');

        $fromInput.add($toInput).on('input', function () {
            this.value = this.value.replace(/[^0-9.,]/g, '');
        });

        let userInteracted = false;

        $fromInput.on('change', function () {
            userInteracted = true;
            let value = $(this).val() === '' ? minValue : parseFloat($(this).val());
            if (value < minValue) { value = minValue; }
            else if (value > parseFloat($toInput.val() || maxValue)) { value = parseFloat($toInput.val() || maxValue); }
            $(this).val(wNumbFormat.to(value));
            rangeSlider.set([value, null]);
        });

        $toInput.on('change', function () {
            userInteracted = true;
            let value = $(this).val() === '' ? maxValue : parseFloat($(this).val());
            if (value > maxValue) { value = maxValue; }
            else if (value < parseFloat($fromInput.val() || minValue)) { value = parseFloat($fromInput.val() || minValue); }
            $(this).val(wNumbFormat.to(value));
            rangeSlider.set([null, value]);
        });

        rangeSlider.on('start', function () {
            userInteracted = true;
        });

        rangeSlider.on('update', function (values, handle, rawValues) {
            if (!userInteracted) { return; }
            $fromInput.val(wNumbDisplayFormat.to(rawValues[0]));
            $toInput.val(wNumbDisplayFormat.to(rawValues[1]));
        });

        rangeSlider.on('change', function (values, handle, rawValues) {
            $container.find('[name="filter[properties][' + propertyId + '][from]"]').val(rawValues[0]);
            $container.find('[name="filter[properties][' + propertyId + '][to]"]').val(rawValues[1]);
            Filter.submit();
            $fromInput.val(wNumbDisplayFormat.to(rawValues[0]));
            $toInput.val(wNumbDisplayFormat.to(rawValues[1]));
        });
    });
}

// ---------------------------------------------------------------------------
// Slider filter bubbles
// ---------------------------------------------------------------------------

function parseSliderInputName(name) {
    var m = String(name || '').match(/^filter\[properties\]\[([^\]]+)\]\[(from|to)\]$/);
    if (!m) return null;
    return {
        propertyId: m[1],
        endpoint: m[2],
        fromName: 'filter[properties][' + m[1] + '][from]',
        toName: 'filter[properties][' + m[1] + '][to]',
        bubbleKey: 'slider-property-' + m[1],
    };
}

function toSliderNumber(v) {
    var raw = String(v == null ? '' : v).replace(',', '.').replace(/[^\d.-]/g, '');
    if (raw === '') return null;
    var n = parseFloat(raw);
    return Number.isNaN(n) ? null : n;
}

function refreshSliderBubbleFromInput($elem) {
    var meta = parseSliderInputName($elem.attr('name'));
    if (!meta) return false;
    if (meta.endpoint !== 'from') return true;

    var $container = $('.filter-property-slider[data-property-id="' + meta.propertyId + '"]');
    var $range = $container.find('.js-range-property');
    if (!$container.length || !$range.length) { return true; }

    var min = toSliderNumber($range.attr('data-min'));
    var max = toSliderNumber($range.attr('data-max'));
    var unit = String($range.attr('data-unit') || '').trim();

    var $from = $container.find('[name="' + meta.fromName + '"]');
    var $to = $container.find('[name="' + meta.toName + '"]');
    var fromVal = String($from.val() || '').trim();
    var toVal = String($to.val() || '').trim();

    $('.js-filter-bubbles-item[data-filter-key="' + meta.bubbleKey + '"]').remove();
    $('[data-element="filterBubbles"]').attr('data-count', $('.filter__bubbles__item').size());

    var isActive = fromVal !== '' || toVal !== '';
    if (!isActive) {
        rEvent.dispatch('FilterBubbles.returnedRefresh');
        return true;
    }

    var from = fromVal === '' ? min : toSliderNumber(fromVal);
    var to = toVal === '' ? max : toSliderNumber(toVal);
    if (from == null || to == null || min == null || max == null) {
        rEvent.dispatch('FilterBubbles.returnedRefresh');
        return true;
    }

    var unitStr = unit ? ' ' + unit : '';
    FilterBubbles.add({
        url: '#',
        _class: meta.bubbleKey,
        title: '',
        key: meta.bubbleKey,
        value: encodeURIComponent(String(from) + '-' + String(to)),
        content: String(from) + unitStr + ' – ' + String(to) + unitStr,
    });

    rEvent.dispatch('FilterBubbles.afterRefresh');
    return true;
}

var _originalRefresh = FilterBubbles.refresh;
FilterBubbles.refresh = function ($elem) {
    if (refreshSliderBubbleFromInput($elem)) { return; }
    return _originalRefresh.call(this, $elem);
};

// Capture-phase click handler for slider bubble removal
document.addEventListener('click', function (e) {
    var bubble = e.target.closest && e.target.closest('.js-filter-bubbles-item');
    if (!bubble) return;

    var key = String(bubble.getAttribute('data-filter-key') || '');
    if (key.indexOf('slider-property-') !== 0) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var propertyId = key.replace('slider-property-', '');
    var $container = $('.filter-property-slider[data-property-id="' + propertyId + '"]');
    var $range = $container.find('.js-range-property');
    var min = toSliderNumber($range.attr('data-min'));
    var max = toSliderNumber($range.attr('data-max'));

    $container.find('[name="filter[properties][' + propertyId + '][from]"]').val('');
    $container.find('[name="filter[properties][' + propertyId + '][to]"]').val('');
    $container.find('.filter-property-from, .filter-property-to').val('');

    var inst = $range.data('rangeSlider');
    if (inst && min != null && max != null) {
        inst.set([min, max]);
        $container.find('[name="filter[properties][' + propertyId + '][from]"]').val('');
        $container.find('[name="filter[properties][' + propertyId + '][to]"]').val('');
        $container.find('.filter-property-from, .filter-property-to').val('');
    }

    $(bubble).remove();
    $('[data-element="filterBubbles"]').attr('data-count', $('.filter__bubbles__item').size());
    rEvent.dispatch('FilterBubbles.returnedRefresh');

    if (window.Filter && typeof window.Filter.submit === 'function') {
        window.Filter.submit();
    }
}, true);

// Refresh slider bubbles before every submit
rEvent.on('Filter.beforeSubmit', function () {
    if (!window.Filter || !Filter.bubbles) return;
    $('[name$="[from]"]').filter(function () {
        return parseSliderInputName(this.name) !== null;
    }).each(function () {
        Filter.bubbles.refresh($(this));
    });
});

FilterBubbles.create = function (filterSelector, options) {
    this.template = options.template;
    this.clearFilterTemplate = options.clearFilterTemplate;

    this.initialize();

    rEvent.dispatch('FilterBubbles.created');

    return this;
}

FilterBubbles.add = function (data) {
    if (!data.content) {
        return;
    }

    if ($(this.container).find('.js-filter-bubbles-reset').length == 0) {
        $(this.container).prepend(_.template(this.clearFilterTemplate)({
            _class: ''
        }));
    }

    $(this.container).append(_.template(this.template)(data));
    $('[data-element="filterBubbles"]').attr('data-count', $(this.holder).size());

    rEvent.dispatch('FilterBubbles.added');
}

$(function () {
    renderMultiselect();
    renderFilterBubbles();

    if ($('.filter-price').length > 0) {
        createPriceRange();
    }

    if ($('.filter-property-slider').length > 0) {
        createPropertySliders();
    }

    // fake sort
    const sortValue = $sort.val();

    if (sortValue) {
        $fakeSort.val(sortValue);
        changeFakeSortButton(sortValue);
    }

    $fakeSort.on('change', function () {
        const value = $(this).val();

        $sort.val(value).trigger('change');
    });

    $fakeSortButtons.on('click', '.c-btn', function () {
        const value = $(this).data('value');

        changeFakeSortButton(value);
        $sort.val(value).trigger('change');
    });

    // fake limit
    $fakeLimit.on('change', function () {
        const value = $(this).val();

        $limit.val(value);

        Filter.submit();
    });

    // fake view
    let viewValue = getCookie('listingView');

    if (viewValue) {
        $('.js-fake-view#' + viewValue).addClass('is-active');
    } else {
        $('.js-fake-view#grid').addClass('is-active');
    }

    $fakeView.on("click", function () {
        viewValue = $(this).data('value');

        $view.val(viewValue).change();
    });

    rEvent.on('Listing.changeView', function () {
        const $view = $('#filter-view'),
            value = $view.val();

        $('.js-fake-view').removeClass('is-active');
        $('.js-fake-view#' + value).addClass('is-active');

        $(".products")
            .removeClass("products--row")
            .removeClass("products--grid");
        $(".products").addClass("products--" + value);

        $(".products .js-thumb")
            .removeClass("is-row")
            .removeClass("is-grid");
        $(".products .js-thumb").addClass("is-" + value);
    });

    // filter reset
    rEvent.on("Filter.reset", function () {
        const $inputFrom = $('#filter-price-from'),
            fromValue = Number($inputFrom.attr('min')),
            $inputTo = $('#filter-price-to'),
            toValue = Number($inputTo.attr('max'));

        $inputFrom.val(fromValue);
        $inputTo.val(toValue);

        if ($rangeSlider) {
            $rangeSlider.set([fromValue, toValue]);
        }

        $('.js-filter-price-range:checked').prop('checked', false);

        $('.filter-property-slider').each(function () {
            const $container = $(this);
            const $range = $container.find('.js-range-property');
            const minVal = parseFloat($range.attr('data-min'));
            const maxVal = parseFloat($range.attr('data-max'));
            const inst = $range.data('rangeSlider');
            if (inst && inst.set) {
                inst.set([minVal, maxVal]);
            }
            // Clear after set() — the 'update' event overwrites inputs with min/max values
            $container.find('.filter-property-from, .filter-property-to').val('');
        });
    });

    $('.js-filter-price-range').on('change', function () {
        const $checkedInput = $('.js-filter-price-range:checked'),
            priceArray = $checkedInput.val().split(';'),
            actualMin = parseFloat(priceArray[0]),
            actualMax = parseFloat(priceArray[1]);

        let min = 99999,
            max = 0;

        if (actualMin < min) {
            min = actualMin;
        }

        if (actualMax > max) {
            max = actualMax;
        }

        $('#filter-price-from').val(min);
        $('#filter-price-to').val(max);

        $rangeSlider.set([min, max]);

        Filter.submit();
    });

    $(document).on('click', '.pager__list a', function (event) {
        event.preventDefault();

        $.get($(this).attr('href'), {}, function (data) {
            Listing.callbacks.update(data);
        }, 'json');

        $(this).addClass('is-loading');

        if ($('.listing__holder').length) {
            $('.listing__holder').addClass('is-loading');
        }
    });

    $(document).on('click', '.pager__load', function (event) {
        $(this).addClass('is-loading');
    });
});
